import { BasemapOptionEntity } from '@gishub/domain';
import { IBasemapSourceStrategy } from '../strategies/i-basemap-source-strategy';
import { IBasemapSourceStrategyConfig } from '../strategies/i-basemap-source-strategy-config';

export abstract class BasemapDecorator implements IBasemapSourceStrategy {
  constructor(protected readonly strategy: IBasemapSourceStrategy) {}

  abstract createConfig(option: BasemapOptionEntity): IBasemapSourceStrategyConfig;
}
